import { Injectable } from '@angular/core';
import { ToastController } from "ionic-angular";

////////////////////////////////////..........
///// Toast Service 
///// 用途 Ionicアラートの表示制御
///// 当Serviceを通すことで連続表示を制御する
////////////////////////////////////..........

@Injectable()
export class ToastService {

  isShowModal: boolean;

  constructor(
    private toastCtrl: ToastController,
  ) {
    this.isShowModal = false;
  }

  /**
   * トースト表示
   * @param message
   * @param subTitleduration
   * @param position
   */
  basic(message: string, duration: number, position: string): void {
    if (this.isShowModal) return;
    this.isShowModal = true;
    let toast = this.toastCtrl.create({
      message: message,
      duration: duration,
      position: position,
    });
    toast.present();
    toast.onDidDismiss(() => this.isShowModal = false);
  }

}



// WEBPACK FOOTER //
// ./src/providers/toast.service.ts